import { createStore } from 'owa-satcheljs';
import type { ClientItem } from 'owa-mail-store';
import type { Point } from '@fluentui/react/lib/Utilities';

interface SelectionPopupStore {
    point?: Point | HTMLElement;
    showPopup: boolean;
    selectedText?: string;
    element?: HTMLElement;
    item?: ClientItem;
    isForExistingUserHighlight: boolean;
    isForExistingUserNote: boolean;
    selectionRange?: Range;
    selectionInstance?: number;
    targetWindow?: Window | null;
}

const defaultSelectionPopupStore: SelectionPopupStore = {
    point: undefined,
    showPopup: false,
    selectedText: undefined,
    element: undefined,
    item: undefined,
    isForExistingUserHighlight: false,
    isForExistingUserNote: false,
    selectionRange: undefined,
    selectionInstance: undefined,
    targetWindow: undefined,
};

const defaultExport: () => SelectionPopupStore = createStore<SelectionPopupStore>(
    'SelectionPopupStore',
    defaultSelectionPopupStore
);
export default defaultExport;
